import type {
  AccidentReportViewModel,
  VehicleKey,
} from "#accident-statement/schema";
import {
  createContext,
  useContext,
  type Dispatch,
  type SetStateAction,
} from "react";
import type { TicketViewModel } from "../api/TicketViewModel";
import type { ReportSubscriptionSubject } from "../api/ReportSubscriptionSubject";

export interface ReportResult {
  data: AccidentReportViewModel;
  party: VehicleKey;
  ticket: TicketViewModel<ReportSubscriptionSubject>;
}

export interface ILoadReportContext {
  report: ReportResult;
  updateReport: Dispatch<SetStateAction<AccidentReportViewModel>>;
  loaded: Date;
  updated: Date;
  refresh(): Promise<void>;
  isSubscribed: boolean;
}

export const LoadReportContext = createContext<ILoadReportContext | null>(null);

export function useLoadReportContext() {
  const context = useContext(LoadReportContext);
  if (!context) throw new Error("No LoadReportContext found!");
  return context;
}
